import {defineStore} from "pinia";


export const useConsultorioStore = defineStore("consultorioStore", {
    state: () =>
        ({
            loading: false as boolean,
            showDialog: false as boolean,
            showDialogFuncionario: false as boolean,
            consultas: [],
            reservas: [],
            pacientes: [],
            tratamientos: [],
            paciente: {},
            documentos: [],
            cotizaciones: [],
            pagos: [],
            historialMedico: [] as any[],
            pagos_pendientes: Array as any,
            reconsultas: Array as any,
            convenios: Array as any,
            dataReporte: Array as any,
            dataHome: Array as any,
            pagination: {
              per_page: 0,
              current_page: 1,
              last_page: 0,
            },
            
        }),
});